import { HTTPCodes } from '@lib/httpCodes';

export class NotImplementedError extends Error {
    public code!: number;
    public report!: boolean;

    constructor(message: string) {
        super();

        Error.captureStackTrace(this, this.constructor);

        this.code = HTTPCodes.HTTP_NOT_IMPLEMENTED;
        this.name = 'NotImplementedError';
        this.message = message;
        this.report = true;
    }
}
